// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.error[data-v-f70427fe]{border:1px solid #d0021b}", ""]);
// Exports
module.exports = exports;
